@if (account && account.utility && account.rateClass && account.state) {
@if (isFromOffer) {
@if (hasHighlightedFields()) {
<div>Fields highlighted in yellow require completion.</div>
}
<input type="text"
       name="accountNumber"
       (input)="resetErrorPlusEvent('accountNumber')"
       placeholder="Account Number"
       [formControl]="currentAccountNumber"
       [dropSpecialCharacters]="false"
       [mask]="account.utility.accountTemplate"
       (focus)="focusField('accountNumber')"
       (focusout)="focusOutField('accountNumber');"
       [showMaskTyped]="(focusedField()=='accountNumber') || ((currentAccountNumber.value!=null) && (currentAccountNumber.value!=''))"
       [class]="getClassesForInput('accountNumber', true, ((currentAccountNumber.value==null)?'':currentAccountNumber.value?.trim())) + ((focusedField()=='accountNumber') || ((currentAccountNumber.value!=null) && (currentAccountNumber.value!=''))?' ls-5':'') + ((currentAccountNumber.value!=null && currentAccountNumber.value.length>0)?'':' highlighted')" />
@if (getVisibilityForLabel(((currentAccountNumber.value==null)?'':currentAccountNumber.value?.trim())+((focusedField()=='accountNumber')?'account':''))) {
<div class="placeholder">Account Number</div>
}
}
@if (!isFromOffer) {
<input type="text" name="UtilityID"
       [class]="getClassesForInput('UtilityID', true, account.utility.name)"
       [value]="account.utility.name" disabled="disabled" />
@if (getVisibilityForLabel(account.utility.name)) {
<div class="placeholder">Utility</div>
}
@if (!disabledDelete) {
   <div class="right-margin-icon info-icon after-placeholder link" (click)="iIconPopup('It is not allowed to update utility, load zone and rate class during editing of account. If needed, please, delete the current account and create a new one.');"></div>
}
<input type="text" name="LoadZoneID"
       [class]="getClassesForInput('LoadZoneID', true, (account.loadZone==null)?'':account.loadZone.name)"
       [value]="(account.loadZone==null)?'':account.loadZone.name"
       disabled="true" />
@if (getVisibilityForLabel((account.loadZone==null)?'':account.loadZone.name)) {
<div class="placeholder">Load Zone</div>
}
<input type="text" name="RateClassID"
       [class]="getClassesForInput('RateClassID', true, account.rateClass.name)"
       [value]="account.rateClass.name" disabled="disabled" />
@if (getVisibilityForLabel(account.rateClass.name)) {
<div class="placeholder">Rate Class</div>
}
}
@if (!isFromOffer) {
<input type="text"
       name="accountNumber"
       (input)="resetErrorPlusEvent('accountNumber')"
       placeholder="Account Number"
       [formControl]="currentAccountNumber"
       [dropSpecialCharacters]="false"
       [mask]="account.utility.accountTemplate"
       (focus)="focusField('accountNumber')"
       (focusout)="focusOutField('accountNumber'); mapAccountNumber();"
       [showMaskTyped]="(focusedField()=='accountNumber') || ((currentAccountNumber.value!=null) && (currentAccountNumber.value!=''))"
       [class]="getClassesForInput('accountNumber', true, ((currentAccountNumber.value==null)?'':currentAccountNumber.value?.trim())) + ((focusedField()=='accountNumber') || ((currentAccountNumber.value!=null) && (currentAccountNumber.value!=''))?' ls-5':'')" />
@if (getVisibilityForLabel(((currentAccountNumber.value==null)?'':currentAccountNumber.value?.trim())+((focusedField()=='accountNumber')?'account':''))) {
<div class="placeholder">Account Number</div>
}
}
<input type="text"
       name="serviceName"
       [class]="getClassesForInput('serviceName', true, account.serviceName)+((!isFromOffer || (account.serviceName!=null && account.serviceName.length>0))?'':' highlighted')"
       (input)="resetErrorPlusEvent('serviceName')"
       placeholder="Customer Name"
       [(ngModel)]="account.serviceName"
       [minlength]="validationService.getMinLength('Account', 'serviceName')"
       [maxlength]="validationService.getMaxLength('Account', 'serviceName')" />
@if (getVisibilityForLabel(account.serviceName)) {
<div class="placeholder">Customer Name</div>
}
<input type="text"
       name="keyName"
       [class]="getClassesForInput('keyName', true, account.keyName)"
       (input)="resetError('keyName')"
       placeholder="Shopping ID"
       [(ngModel)]="account.keyName"
       [minlength]="validationService.getMinLength('Account', 'keyName')"
       [maxlength]="validationService.getMaxLength('Account', 'keyName')" />
@if (getVisibilityForLabel(account.keyName)) {
<div class="placeholder">Shopping ID</div>
}
<input type="text"
       name="address"
       [class]="getClassesForInput('addressLine1', true, account.addressLine1)+((!isFromOffer || (account.addressLine1!=null && account.addressLine1.length>0))?'':' highlighted')"
       (input)="resetErrorPlusEvent('addressLine1')"
       placeholder="Service Address"
       [(ngModel)]="account.addressLine1"
       [minlength]="validationService.getMinLength('Account', 'address')"
       [maxlength]="validationService.getMaxLength('Account', 'address')" />
@if (getVisibilityForLabel(account.addressLine1)) {
<div class="placeholder">Service Address</div>
}
<input type="text"
       name="address2"
       [class]="getClassesForInput('addressLine2', false, account.addressLine2)"
       (input)="resetErrorPlusEvent('addressLine2')"
       placeholder="Address Line 2"
       [(ngModel)]="account.addressLine2"
       [minlength]="0"
       [maxlength]="validationService.getMaxLength('Account', 'address')" />
@if (getVisibilityForLabel(account.addressLine2)) {
<div class="placeholder">Address Line 2</div>
}
<div class="cols">
    <div class="col">
        <select [class]="getClassesForInput('city', true, account.city)"
                name="city"
                (change)="resetErrorPlusEvent('city');"
                [(ngModel)]="account.city">
            @if (account.city==null) {
            <option [ngValue]="null" [disabled]="true">City</option>
            }
            @for (city of cities; track city) {
            <option [ngValue]="city">{{city}}</option>
            }
        </select>
        @if (getVisibilityForLabel(account.city)) {
        <div class="placeholder">City</div>
        }
    </div>
    <div class="col">
        <input type="text" name="stateId"
               style="width: 60px !important;"
               [class]="getClassesForInput('stateId', true, account.state.stateCode)"
               [value]="account.state.stateCode" disabled="disabled" />
        @if (getVisibilityForLabel((account.state==null)?null:account.state.stateCode)) {
        <div class="placeholder">State</div>
        }
    </div>
    <div class="col">
        <input type="text"
               name="address"
               [class]="'min-input-width '+getClassesForInput('zip', true, account.zip)+((!isFromOffer || (account.zip!=null && account.zip.length>0))?'':' highlighted')"
               (input)="resetErrorPlusEvent('zip')"
               placeholder="Zip"
               [(ngModel)]="account.zip"
               [minlength]="validationService.getMinLength('Account', 'zip')"
               [maxlength]="validationService.getMaxLength('Account', 'zip')" />
        @if (getVisibilityForLabel(account.zip)) {
        <div class="placeholder">Zip</div>
        }
    </div>
</div>
@if (!isFromOffer) {
<div class="mb-10">
    <label>
        <input type="checkbox" name="isActive" [(ngModel)]="account.isActive" [checked]="account.isActive" /> Account is active
    </label>
</div>
}
<div class="mb-10">
    <label><input type="checkbox" value="1" [checked]="isCommercial()" [disabled]="this.account.rateClass?.isCommercial" (change)="changeCommercial()" /> Account is commercial</label>
</div>
@if (isCommercial()) {
@if(!newCompanyRegistration()) {
<div>
    <select name="company" [class]="getClassesForInput('selectCompany', true, null)+' placeholder'" [compareWith]="compareFn" [(ngModel)]="account.company" (change)="selectExistingCompany()">
        <option [ngValue]="null" [disabled]="true">Select Company</option>
        @for (company of userCompanies; track company) {
        <option [ngValue]="company">{{company.name}}</option>
        }
    </select>
    <div class="placeholder" style="text-align: right; padding-right: 28px;"><a (click)="setNewCompany()">Add New Company</a></div>
</div>
}
@if(newCompanyRegistration()) {
<div>
    <input type="text" name="companyName" [class]="getClassesForInput('companyName', true, account.company!.name)" placeholder="Company Name" (input)="resetError('companyName')" [(ngModel)]="account.company!.name" />
    @if (getVisibilityForLabel(account.company!.name)) {
    <div class="placeholder">Company Name</div>
    }
    @if (this.userCompanies!=null && this.userCompanies.length>0) {
    <div style="text-align: right; font-size: 13px; margin-top: -5px;"><a (click)="switchToCompanySelect();">Select from existing companies</a></div>
    }
</div>
}
<div>
    <div class="mb-10 mt-10">
        <label>
            <input type="checkbox" name="taxExempt" (change)="taxExemptChanged()" [disabled]="!newCompanyRegistration() && !taxExemptAllowToAdd()" [(ngModel)]="taxExempt" /> Is your business
            tax exempt?
        </label>
    </div>
    @if (account.company!=null && taxExempt && account.company.taxExempt) {
    <div>
        <input type="text" name="FederalTaxID" class="w-100"
               [class]="getClassesForInput('FederalTaxID', true, account.company.federalTaxID)" value=""
               (input)="resetError('FederalTaxID')" [(ngModel)]="account.company.federalTaxID"
               [disabled]="!newCompanyRegistration() && !taxExemptAllowToAdd()"
               placeholder="Federal Tax ID" />
        @if (getVisibilityForLabel(account.company.federalTaxID)) {
        <div class="placeholder">Federal Tax ID</div>
        }
        <div class="mt-20"> Please upload a photo or a copy of your tax exempt certificate.</div>
        @if ((fileToUpload==null) && account.company.taxExemptCertificateDocument==null) {
        <label class="formLabel"
               [class]="(errorY().isWrong('fileToUpload'))?'error':''">
            CHOOSE FILES
            <span>no files selected</span>
            <input type="file" name="taxExemptCertificateDocument" class="required" value=""
                   placeholder="Tax Exempt Certificate Document" [disabled]="!newCompanyRegistration() && !taxExemptAllowToAdd()" (change)="handleFileInput($event)" />
        </label>
        }
        @if (fileToUpload!=null || account.company.taxExemptCertificateDocument!=null) {
        <div class="files-list">
            <span>File selected</span>
            <ul>
                @if (account.company.taxExemptCertificateDocument!=null) {
                <li>
                    @if (newCompanyRegistration() || taxExemptAllowToAdd()) {
                    <a (click)="deleteExistingFile(account.company.taxExemptCertificateDocument.key)"></a>
                    }
                    <div class="link" (click)="downloadFile(true, account.company.taxExemptCertificateDocument.key)">{{account.company.taxExemptCertificateDocument.value}}</div>
                </li>
                }
                @if (fileToUpload!=null) {
                <li>
                    @if (newCompanyRegistration() || taxExemptAllowToAdd()) {
                    <a (click)="deleteFile()"></a>
                    }
                    <div class="link" (click)="downloadFile(false, null)">{{fileToUpload.name}}</div>
                </li>
                }
            </ul>
        </div>
        }
    </div>
    }
</div>
}
@if (this.errorY().showError() && errorY().error!='accountissue') {
<div class="error-block">
    {{this.errorY().error}}
</div>
}
@if (this.errorY().showError() && errorY().error=='accountissue') {
<div class="error-block">
    The account number you entered is already in use. Please verify the number and try again. If you believe that your account number has been used without your authorization, please <a (click)="reportAccountIssue()">click here</a> to report it to kilowant for investigation.
</div>
}

}
